import { chordSheetTooBig } from "@bandstand/core/ChordSheet";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import styled from "styled-components";

import { useStores } from "../../stores/useStores";
import { color } from "../../theme/color";
import { FieldLabel } from "../ui/controls";
import { Dialog } from "../ui/Dialog";
import { TextField } from "../ui/TextField";

/** Adds a song with its first chord sheet. Lyrics and chords can be pasted in now, or added later. */
export const AddSongDialog = observer(function AddSongDialog({ onClose }: { onClose(): void }) {
    const { library, navigation } = useStores();
    const [title, setTitle] = useState("");
    const [artist, setArtist] = useState("");
    const [text, setText] = useState("");
    const tooBig = chordSheetTooBig(text);

    async function add() {
        const { song } = await library.change((l) => l.addSong({ title: title.trim(), artist: artist.trim() || undefined }, text));

        onClose();
        navigation.go({ name: "songs", songId: song.id });
    }

    return (
        <Dialog title="Add a song" submit="Add" canSubmit={!!title.trim() && !tooBig} onSubmit={add} onClose={onClose}>
            <FieldLabel>
                Title
                <TextField autoFocus value={title} onChange={setTitle} />
            </FieldLabel>
            <FieldLabel>
                Artist <Hint>(optional)</Hint>
                <TextField value={artist} onChange={setArtist} />
            </FieldLabel>
            <FieldLabel>
                <span>
                    Lyrics and chords in ChordPro <Hint>(optional, like [G]Amazing [C]grace)</Hint>
                </span>
                <ChordProField spellCheck={false} value={text} onChange={(event) => setText(event.target.value)} />
                {tooBig && <TooBig>This is too long for a chord sheet.</TooBig>}
            </FieldLabel>
        </Dialog>
    );
});

const ChordProField = styled.textarea`
    min-height: 160px;
    padding: 10px 12px;
    border: 1px solid ${color.borderStrong};
    border-radius: 10px;
    background: ${color.background};
    font-family: ui-monospace, "SF Mono", Menlo, Consolas, monospace;
    font-size: 14px;
    line-height: 1.5;
    resize: vertical;
`;

const Hint = styled.span`
    font-weight: 400;
    color: ${color.textMuted};
`;

const TooBig = styled.span`
    font-weight: 400;
    color: ${color.danger};
`;
